import { render, staticRenderFns } from "./StockTrendQueryView.vue?vue&type=template&id=126e7c46&scoped=true"
import script from "./StockTrendQueryView.vue?vue&type=script&lang=js"
export * from "./StockTrendQueryView.vue?vue&type=script&lang=js"
import style0 from "./StockTrendQueryView.vue?vue&type=style&index=0&id=126e7c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e7c46",
  null
  
)

export default component.exports